import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/froggytalk.webp';
import screenshot_target from '../../../images/letterfunnel/oluseyiakinnibosun.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Oluseyi Akinnibosun"
      firstname="Oluseyi"
      companyname="FroggyTalk"
      competition="Talk360 en AfriCallShop"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/oluseyiakinnibosun.js